// LIBRARIES
import { useState, useEffect } from "react";

// MUI
import Box from "@mui/material/Box";

// STYLES
import { downTime as classes } from './style';

// CONSTANTS
const ALERT = "Scheduled Downtime: Our service will be unavailable from Friday, 2024-11-08, 14:00 (CET) for approx. 1 hour for maintenance. We apologize for any inconvenience caused.";
const start = 1731070800000; // Nov 08 2024, 14:00 CET in milliseconds
const duration = 60 * 60 * 1000; // 1 hour in milliseconds

const DownTime = () => {
    const [now, setNow] = useState(Date.now());
    const endTime = start + duration;

    useEffect(() => {
        const interval = setInterval(() => setNow(Date.now()), 60 * 1000);

        // Clear interval after 1 hour from the start time has passed
        if (now > endTime) {
            clearInterval(interval);
        }

        return () => clearInterval(interval);
    }, [now, endTime]);

    // Check if the current time is within the start and end time
    const isDowntime = now >= start && now <= endTime;

    if (!isDowntime) return null; // Don't render if not within the downtime window

    return (
        <Box sx={classes.banner}>
            <Box sx={classes.scrollText}>
                {ALERT}
            </Box>
        </Box>
    );
};

export default DownTime;